import shallow from 'zustand/shallow';
import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Iconmoon from '@deprecated-ui/common/Iconmoon';
import color from '@deprecated-ui/_style/color';
import { Divider } from 'antd';
import If from 'global/ErrorHandlers/If';
import PnLCurrency from 'features/trade/components/Portfolio/PnLCurrency';
import { formatBondCurrency } from 'features/securities/withdrawal/utils';
import {
  ModalBody,
  ModalContainer,
  ModalHeader,
  ModalRoot,
} from '../../styled';
import { useBondTaxStore } from '../../stores/useBondTaxStore';
import { Container, Field, FieldSet } from './styled';

export default function ModalBondTax() {
  const [isVisible, closeTaxModal, accruedInterest, pl, amount, totalTax] =
    useBondTaxStore(
      (s) => [
        s.isVisible,
        s.closeTaxModal,
        s.accruedInterest,
        s.pl,
        s.amount,
        s.totalTax,
      ],
      shallow,
    );

  const isFree = totalTax <= 0;

  return (
    <ModalRoot visible={isVisible} onCancel={closeTaxModal} zIndex={2000}>
      <ModalContainer>
        <ModalHeader>
          {/* @ts-expect-error */}
          <Flex justify="between" align="center" w="100%">
            <Text
              family="bold"
              size="18px"
              // @ts-expect-error
              mt="0"
              width="100%"
              data-cy="bonds-modal-header"
              align="center"
            >
              Pajak Obligasi
            </Text>
            <Iconmoon
              className="icon-trading_x"
              color="#333333"
              size="12px"
              onClick={closeTaxModal}
            />
          </Flex>
        </ModalHeader>
        <ModalBody
          css={`
            width: 375px;
          `}
        >
          <Container>
            <div>
              <FieldSet>
                <Field>
                  <div>Kupon Berjalan Kena Pajak</div>
                  <PnLCurrency
                    amount={accruedInterest}
                    isColorless
                    isHidePositiveSign
                  />
                </Field>
                <Field>
                  <span>{pl >= 0 ? 'Keuntungan' : 'Kerugian'}</span>
                  <PnLCurrency amount={pl} isHidePositiveSign isColorless />
                </Field>
              </FieldSet>
            </div>
            <div>
              <Divider
                css={`
                  margin: 0px;
                `}
              />
            </div>
            <div>
              <Field>
                <span>Nominal Kena Pajak</span>
                <PnLCurrency amount={amount} isHidePositiveSign isColorless />
              </Field>
            </div>
          </Container>
          <Container>
            <Field>
              <span>Pajak Obligasi (10%)</span>
              <If condition={!isFree}>
                <Text family="bold">{formatBondCurrency(totalTax)}</Text>
              </If>
              <If condition={isFree}>
                <Text family="bold" color={color.primary}>
                  Bebas Pajak
                </Text>
              </If>
            </Field>
          </Container>
        </ModalBody>
      </ModalContainer>
    </ModalRoot>
  );
}
